import { render, staticRenderFns } from "./AgentTicketServiceList.vue?vue&type=template&id=09df812a&scoped=true&"
import script from "./AgentTicketServiceList.vue?vue&type=script&lang=js&"
export * from "./AgentTicketServiceList.vue?vue&type=script&lang=js&"
import style0 from "./AgentTicketServiceList.vue?vue&type=style&index=0&id=09df812a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09df812a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCol,VDataTable,VRow,VSkeletonLoader})
